export function getPriceLevelLabel(priceLevel: string): string {
    const mappingTitle: any = {
        "primaire": "Tarif achat unité",
        "default": "Tarif achat au carton"
    }

    return mappingTitle[priceLevel?.toLowerCase()] ?? mappingTitle['default']
}